import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetCategories extends Event {
    eventName = 'oms_getCategories';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get categories for given location id
     * 
     * @param {string} data.sort_property -  sort property
     * @param {string} data.sort_direction -  sort direction
     * @param {string} data.type -  type of response
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        let sortProperty = (data.sort_property) ? data.sort_property : 'name';
        let sortDirection = (data.sort_direction) ? data.sort_direction : 'asc';
        let start = (data.start >= 0) ? data.start : null;
        let limit = (data.limit) ? data.limit : null;
        let keyword = (data.keyword) ? data.keyword : null;
        let type = (data.type) ? data.type : 'tree';
        let filterGroups = (data.filter_groups) ? data.filter_groups : null;
        let locationId = (!data.all_location_data) ? new LocalStorage.CurrentLocation(clientId).getData() : null;
        

        // request data
        data.endPoint = application_settings.endPoints.getCategories;
        data.data = {
            client_id: clientId,
            location_id: locationId,
            start: start,
            limit: limit,
            keyword: keyword,
            sort_property: sortProperty,
            sort_direction: sortDirection,
            filter_groups: filterGroups,
            type: type
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //add data to storage
                let categories = new LocalStorage.Categories(locationId);
                categories.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data,  {'action' : action, 'request_id' : requestId });
            }
        });

    }
}

export default GetCategories;